import React from "react";
import { X } from "lucide-react";
import { resolveIcon } from "@/lib/icons";
import { formatUSD, formatNum } from "@/lib/format";

export function LineItemCard({ item, rate, onEdit, onDelete, readOnly }) {
  const Icon = resolveIcon(item.icon);
  const cost = item.coins * rate;
  return (
    <div
      role="button"
      onClick={() => onEdit(item)}
      data-testid={`line-item-${item.id}`}
      className="group flex items-center gap-3 rounded-xl border border-border bg-surface-2 px-4 py-3 mb-2 cursor-pointer transition-colors hover:border-border-strong"
    >
      <div
        className="flex h-10 w-10 items-center justify-center rounded-lg shrink-0"
        style={{ backgroundColor: `${item.color}1F` }}
      >
        <Icon size={19} style={{ color: item.color }} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-[15px] text-foreground">{item.name}</p>
        <p className="font-mono text-xs text-muted-foreground mt-0.5 tabular">
          {formatNum(item.coins)} coins · {item.category}
        </p>
      </div>
      <span className="font-mono font-bold text-[15px] text-brand tabular">{formatUSD(cost)}</span>
      {!readOnly && (
        <button
          data-testid={`delete-item-${item.id}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item.id);
          }}
          className="p-1 text-border-strong hover:text-danger transition-colors"
          aria-label="Delete task"
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
}
